import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Box, Button, Stack } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { usePermission } from "hooks/permissions";
import { useCanDeploy } from "hooks/useCanDeploy";
import { useCanDownloadExcel } from "hooks/useCanDownloadExcel";
import { useDownloadPlanMixes } from "hooks/useDownloadPlanMixes";
import { useIsBehindFeatureFlag } from "hooks/useFeatureFlag";
import { useIsMobile } from "hooks/useIsMobile";
import { useLocation } from "react-router";
import { usePlanId } from "../../common/boundary/PlanId";
import { BackupButton } from "../backups/backupButton";
import { DeployButton } from "./exportPlan/deployButton";
import { OpenInPage } from "./openInPage";

export const PlanActionButtons = () => {
  const currentLocation = useLocation();
  const isPlanPeek = currentLocation.pathname.endsWith("/search");
  const isMobile = useIsMobile();

  const { t } = useTenantTranslation();
  const planId = usePlanId();
  const canDeploy = useCanDeploy();
  const publisher = usePermission(["publish"]);
  const canDownloadExcel = useCanDownloadExcel();
  const areAutoBackupsEnabled = useIsBehindFeatureFlag("auto_backups");

  const downloadPlanMixes = useDownloadPlanMixes(planId, null);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {isPlanPeek && !isMobile ? <OpenInPage /> : null}

      {canDownloadExcel && !isMobile ? (
        <Button
          startIcon={<CloudDownloadIcon />}
          onClick={() => void downloadPlanMixes()}
        >
          {t("download")}
        </Button>
      ) : null}

      {areAutoBackupsEnabled ? (
        <Box>
          <BackupButton planId={planId} />
        </Box>
      ) : null}

      {canDeploy && publisher ? (
        <Box>
          <DeployButton planId={planId} />
        </Box>
      ) : null}
    </Stack>
  );
};
